import { ReactSVG } from "react-svg";

import { transformDateToLocalDateString } from "helpers";
import { OfficeNoteRow } from "services/api/offices/types";
import { Badge } from "ui/components/Badge";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const OFFICE_NOTE_COLUMNS = (
  handleDeleteClick: (event: React.MouseEvent<HTMLDivElement>, id: string) => void
): Column[] => [
  {
    title: "Bilješka",
    field: "content",
    type: ColumnTypes.custom,
    render: (row: OfficeNoteRow) => (
      <p className="text-sm text-slate-600 whitespace-pre-wrap">{row.content}</p>
    ),
  },
  {
    title: "Unesena",
    field: "created",
    type: ColumnTypes.custom,
    render: (row: OfficeNoteRow) => (
      <span className="text-sm text-slate-500 whitespace-nowrap">
        {transformDateToLocalDateString(row.created ? new Date(row.created) : null)}
      </span>
    ),
  },
  {
    title: "",
    field: "important",
    type: ColumnTypes.custom,
    render: (row: OfficeNoteRow) =>
      row.important ? <Badge text="Važna" variant="warning" height="small" /> : <></>,
  },
  {
    title: "",
    field: "",
    type: ColumnTypes.custom,
    render: (row: OfficeNoteRow) => (
      <div
        onClick={(e) => handleDeleteClick(e, row.id)}
        className="flex justify-end items-center h-[30px] cursor-pointer"
      >
        <ReactSVG src="/media/icons/trash.svg" className="w-4 h-4 stroke-[#bd0000]" />
      </div>
    ),
  },
];
